import React, { useEffect, useState } from 'react';
import { Marker, InfoWindow, useNavermaps } from 'react-naver-maps';
import { getMarkerStyle } from '../utils/mapUtils';

function SingleBoreholeMarker({ map, borehole }) {
  const { fillColor, borderColor } = getMarkerStyle(borehole.soil_type, borehole.is_temp_soil_type);
  const navermaps = useNavermaps();
  const [infoWindow, setInfoWindow] = useState(null);
  const markerIcon = {
    content: `
      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24">
        <circle cx="12" cy="12" r="10" fill="${fillColor}" stroke="${borderColor}" stroke-width="2" />
      </svg>`,
    size: new navermaps.Size(24, 24),
    anchor: new navermaps.Point(12, 12),
  };

  useEffect(() => {
    if(infoWindow){
      infoWindow.open(map, new navermaps.LatLng(borehole.grs80_x, borehole.grs80_y))
    }
  }, [infoWindow]);

  
  return (
    <>
      <Marker
        key={borehole.id}
        position={new navermaps.LatLng(borehole.grs80_x, borehole.grs80_y)}
        icon={markerIcon}
      />
      <InfoWindow
        content={`
          <div style="padding: 5px">
          액상화 예비 평가: <b>${borehole.liquefaction_assessment}</b>
          </div>
          `} // 툴팁으로 액상화 평가 표시
        ref={setInfoWindow}
      />
    </>
  );
}

export default SingleBoreholeMarker;